import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ConsultantDashboard.css';
import { useClients } from '../hooks/useClients';
import { useUser } from '../contexts/UserContext';

function ConsultantDashboard() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const { clients, loading, error } = useClients(false);
  const { user, updateUser } = useUser();
  
  const userPermissions = {
    canAccessDashboard: user?.role === 'admin' || user?.role === 'consultant'
  };

  // Redirect hvis brugeren ikke har adgang
  React.useEffect(() => {
    if (!userPermissions.canAccessDashboard) {
      navigate('/dataexchange');
    }
  }, [userPermissions.canAccessDashboard, navigate]);

  const filteredClients = clients
    .filter(client => client.active) // Filtrer kun aktive kunder
    .filter(client => 
      client.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.cvr.includes(searchTerm)
    );

  const handleClientClick = (clientId) => {
    const selectedClient = clients.find(client => client.id === clientId);
    if (selectedClient) {
      const updatedUser = { 
        ...user, 
        clientId: clientId, 
        clientName: selectedClient.name, 
        databaseName: selectedClient.database_name 
      };
      updateUser(updatedUser);
    }
    navigate(`/client/${clientId}/dataexchange`);
  };

  if (loading) return <div className="loading-spinner">Indlæser...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="consultant-dashboard">
      <div className="dashboard-header">
        <h2>Kundeoversigt</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Søg efter navn eller CVR..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <i className="fas fa-search search-icon"></i>
        </div>
      </div>

      <div className="clients-grid">
        {filteredClients.map(client => (
          <div 
            key={client.id} 
            className="client-card"
            onClick={() => handleClientClick(client.id)}
          >
            <div className="client-info">
              <h3>{client.name}</h3>
              <p className="cvr">CVR: {client.cvr}</p>
              <p className="contact">Kontakt: {client.contact_person}</p>
              <p className="email">{client.email}</p>
            </div>
            <div className="client-status">
              <span className={`status-badge ${client.active ? 'active' : 'inactive'}`}>
                {client.active ? 'Aktiv' : 'Inaktiv'}
              </span>
            </div>
          </div>
        ))}
        {filteredClients.length === 0 && (
          <div className="no-results">
            <i className="fas fa-search"></i>
            <p>Ingen kunder matcher søgningen</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ConsultantDashboard; 